// extracted by mini-css-extract-plugin
module.exports = {"table":"QuoteTab_table__5n4SE","header":"QuoteTab_header__1_OUm","total":"QuoteTab_total__1lj3G"};